// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA8hVGtqgCeXSOjDAl81KzFR10G09MkKVQ",
  authDomain: "hatbazar-97971.firebaseapp.com",
  projectId: "hatbazar-97971",
  storageBucket: "hatbazar-97971.appspot.com",
  messagingSenderId: "12570084317",
  appId: "1:12570084317:web:46fdba8c7f453405afac34"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);